<template>
    <div class="app" id="gwi-developing">
        <div class="developing">
            <p>正在升级维护中...</p>
            <p class="small">功能正在升级维护中，敬请期待</p>
        </div>
    </div>
</template>
<script>
    module.exports = {
        data: function() {
            return {
            }
        }
    }
</script>
<style lang="scss">
    .developing {
        margin-top: 120px;
        padding-top: 36%;
        color: #333333;
        font-size: 18px;
        text-align: center;
        background: url(../../../static/img/yemian-bg.png) top center no-repeat;
        background-size: 30%;
        .small {
            padding-top: 5px;
            color: #666666;
            font-size: 13px;
        }
    }
</style>


// WEBPACK FOOTER //
// maintaing.vue?71f1587c